import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import {
  VaSidenav,
  VaSidenavItem,
} from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { useFeatureToggle } from '~/platform/utilities/feature-toggles/useFeatureToggle';

const SubmissionsWrapper = ({ children }) => {
  const { TOGGLE_NAMES, useToggleValue } = useFeatureToggle();
  const is686cV2Enabled = useToggleValue(
    TOGGLE_NAMES.accreditedRepresentativePortalSubmit686cV2,
  );

  const { pathname } = useLocation();
  const activeTab = pathname.split('/')[1];
  const isActive = path => (activeTab === path ? true : undefined);
  const sideNavLinks = [
    { label: 'Submit forms and files', route: 'submit-forms-and-files' },
    ...(is686cV2Enabled
      ? [{ label: 'In-progress forms', route: 'in-progress-forms' }]
      : []),
    { label: 'Submission history', route: 'submission-history' },
  ];
  const buildLink = path => `/representative/${path}`;
  return (
    <div className="vads-grid-container vads-u-padding-x--0">
      <h1 className="vads-u-margin-y--0">Submissions</h1>
      <p className="va-introtext vads-u-margin-y--0 vads-u-margin-bottom--2">
        Manage submissions for claimants you represent.
      </p>
      <hr className="vads-u-margin-y--4" aria-hidden="true" />
      <div className="vads-grid-row">
        <div className="vads-u-padding-right--2p5 vads-grid-col-12 vads-u-padding-bottom--4 medium-screen:vads-grid-col-4 desktop:vads-grid-col-4 desktop-lg:vads-grid-col-4">
          <VaSidenav>
            {sideNavLinks.map((sideNavLink, index) => (
              <VaSidenavItem
                key={index}
                href={buildLink(sideNavLink.route)}
                label={sideNavLink.label}
                currentPage={isActive(sideNavLink.route)}
              />
            ))}
          </VaSidenav>
        </div>
        <div className="medium-screen:vads-u-padding-left--2p5 vads-grid-col-12 medium-screen:vads-grid-col-8 desktop-lg:vads-grid-col-8">
          {children}
        </div>
      </div>
    </div>
  );
};

SubmissionsWrapper.propTypes = {
  children: PropTypes.node,
};

export default SubmissionsWrapper;
